'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteProducts = undefined;

var _middleware = require('../../middleware');

var _paths = require('./paths');

/**
 * getProducts
 * 
 * Fetches a list of products.
 * @param {String} feis_id 
 */
var deleteProducts = exports.deleteProducts = function deleteProducts(feis_id) {
  return function (dispatch, getState) {

    var products = (0, _paths.productsPath)(getState(), feis_id);

    // delete the cached version
    if (products) {
      return dispatch({
        feis_id: feis_id,
        type: 'DELETE_UI_PRODUCTS'
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/deleteProducts.js
// module id = 661
// module chunks = 0